function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m51.4685 26.3189c0 10.865-8.8086 19.6735-19.6736 19.6735s-19.6735-8.8085-19.6735-19.6735c0-9.0785 4.0804-13.2539 11.0086-17.7206-.5455 3.972-1.4714 8.2904.495 12.0327.2862-2.453.8066-4.8361 1.5234-7.1308 1.5838-5.0707 3.8169-8.7871 6.6432-13.1475 2.8266 4.361 5.0601 8.078 6.6439 13.1494.7183 2.3004 1.2393 4.6896 1.525 7.1489 1.9801-3.7305 1.0442-8.0846.4991-12.0528 6.9283 4.4667 11.0089 8.642 11.0089 17.7207zm-10.9176 13.357c-1.8637-3.0979-5.1725-4.9668-8.7932-4.9668-3.5991 0-6.905 1.8621-8.7737 4.9304 2.5253 1.6737 5.5542 2.6487 8.8109 2.6487 3.2331 0 6.2417-.9608 8.756-2.6123zm-20.4141-2.4435c2.5909-3.8854 6.9395-6.2275 11.6209-6.2275 4.6944 0 9.0655 2.3703 11.6521 6.2736 2.6994-2.8597 4.3545-6.7164 4.3545-10.9596 0-3.3316-1.0189-6.8471-2.9799-9.5669-.5007 5.5549-2.8258 9.1398-8.2462 11.0589-.042-7.8765-.823-13.3519-4.7466-20.4727-3.9231 7.12-4.7042 12.5948-4.7467 20.4703-5.3165-1.3562-7.7859-5.9278-8.2427-11.0519-1.9589 2.7195-2.9766 6.2321-2.9766 9.5623 0 4.2205 1.6374 8.0586 4.3112 10.9135z",
  fill: "#015168",
  fillRule: "nonzero"
});

var SvgTulistelu = function SvgTulistelu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "46.5666mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 63.5 46.5666",
    width: "63.5mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTulistelu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tulistelu.37c51cf3.svg";
export { ForwardRef as ReactComponent };